export default "__VITE_ASSET__MREIuh2v__"